import { render, staticRenderFns } from "./BaseInputNotLabel.vue?vue&type=template&id=0cdac2b3&"
import script from "./BaseInputNotLabel.vue?vue&type=script&lang=js&"
export * from "./BaseInputNotLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports